import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Mail, Clock, Eye, Zap, FlaskConical, Settings } from 'lucide-react';
import EmailLogsTable from '@/components/admin/EmailLogsTable';
import ScheduledEmailsTable from '@/components/admin/ScheduledEmailsTable';
import EmailPreviewWithRealData from '@/components/admin/EmailPreviewWithRealData';
import EmailStatsCards from '@/components/admin/EmailStatsCards';
import EmailAutomationsPanel from '@/components/admin/EmailAutomationsPanel';
import EmailPlayground from '@/components/admin/EmailPlayground';
import EmailCronJobsPanel from '@/components/admin/EmailCronJobsPanel';

const AdminEmailLogs = () => {
  const [activeTab, setActiveTab] = useState('logs');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">Central de E-mails</h1>
        <p className="text-white/60">
          Visualize emails enviados, agendados, previews, automações e playground de testes
        </p>
      </div>

      {/* Stats Cards */}
      <EmailStatsCards />

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="bg-white/5 border border-white/10 w-full overflow-x-auto flex flex-nowrap justify-start md:justify-center scrollbar-thin scrollbar-thumb-white/10">
          <TabsTrigger 
            value="logs" 
            className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60 whitespace-nowrap"
          >
            <Mail className="w-4 h-4 mr-2" />
            Enviados
          </TabsTrigger>
          <TabsTrigger 
            value="scheduled" 
            className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60 whitespace-nowrap"
          >
            <Clock className="w-4 h-4 mr-2" />
            Agendados
          </TabsTrigger>
          <TabsTrigger 
            value="automations" 
            className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60 whitespace-nowrap"
          >
            <Zap className="w-4 h-4 mr-2" />
            Automações
          </TabsTrigger>
          <TabsTrigger 
            value="cron-jobs" 
            className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60 whitespace-nowrap"
          >
            <Settings className="w-4 h-4 mr-2" />
            Cron Jobs
          </TabsTrigger>
          <TabsTrigger 
            value="playground" 
            className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60 whitespace-nowrap"
          >
            <FlaskConical className="w-4 h-4 mr-2" />
            Playground
          </TabsTrigger>
          <TabsTrigger 
            value="preview" 
            className="data-[state=active]:bg-luxury-pinkBright data-[state=active]:text-white text-white/60 whitespace-nowrap"
          >
            <Eye className="w-4 h-4 mr-2" />
            Preview
          </TabsTrigger>
        </TabsList>

        <TabsContent value="logs" className="mt-6">
          <EmailLogsTable />
        </TabsContent>

        <TabsContent value="scheduled" className="mt-6">
          <ScheduledEmailsTable />
        </TabsContent>

        <TabsContent value="automations" className="mt-6">
          <EmailAutomationsPanel />
        </TabsContent>

        <TabsContent value="cron-jobs" className="mt-6">
          <EmailCronJobsPanel />
        </TabsContent>

        <TabsContent value="playground" className="mt-6">
          <EmailPlayground />
        </TabsContent>

        <TabsContent value="preview" className="mt-6">
          <EmailPreviewWithRealData />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminEmailLogs;
